import { useEffect, useState } from 'react'
import Agree from './Agree'
import BarLoader from 'react-spinners/BarLoader'
// import { useLocation } from 'react-router-dom'

// 隨機一份問卷
const pidArr = [
  'P240903105537546',
  'P240910172157716',
  'P240910172156537',
  'P240910172155417',
  'P240910172154080',
  'P240910172136035',
  'P240910172134591',
  'P240910172132981',
]
function shuffle(array) {
  for (let i = array.length - 1; i > 0; i--) {
    let j = Math.floor(Math.random() * (i + 1))
    ;[array[i], array[j]] = [array[j], array[i]]
  }
  return array
}

function Layout({ setCompletionMessage }) {
  const [ac, setAc] = useState(null)
  const [tk, setTk] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [showShareBtn, setShowShareBtn] = useState(true)
  const [randomPid, setrandomPid] = useState(() => shuffle(pidArr)[0])
  // let { pid } = useParams()
  // pid = 'P' + pid.split('p')[1]
  // 特殊設定
  // const { pathname } = useLocation()

  // pid = 'P' + pid.split('/p')[1]
  // const pid = 'P231206105643'

  // const routePid = 'P' + pathname.toLowerCase().split('/p')[1]
  // console.log('pid', routePid)
  useEffect(() => {
    console.log('問卷編號', randomPid)
  }, [])

  // BarLoader
  const actualInnerWidth = document.body.clientWidth - 20
  // share

  return (
    <>
      <BarLoader
        cssOverride={{ overflow: 'hidden', position: 'fixed', zIndex: '1021' }}
        color="#19b394"
        width={actualInnerWidth}
        loading={isLoading}
      />

      <Agree
        setIsLoading={setIsLoading}
        pid={randomPid}
        setAc={setAc}
        setTk={setTk}
        ac={ac}
        tk={tk}
        setShowShareBtn={setShowShareBtn}
        setCompletionMessage={setCompletionMessage}
      />
    </>
  )
}

export default Layout
